import { makeStyles } from "@material-ui/core";
import moment from "moment";

import { Card } from "../../../../components/card/Card";
import { CardActions } from "../../../../components/card/CardActions";
import { CardContent } from "../../../../components/card/CardContent";
import { CardHeader } from "../../../../components/card/CardHeader";
import { NeutralAction } from "../../../../components/card/NeutralAction";
import { PositiveAction } from "../../../../components/card/PositiveAction";
import { MenuButton } from "../../../../components/menu/MenuButton";
import { ChangeTimeMenuItem } from "../../../../task/change-time/ChangeTimeMenuItem";
import { AdhocCustomerTaskDocument } from "../../../../task/task.model";
import { useCloseTask } from "../../close-task.hook";
import { usePlanCustomerFollowUp } from "../../plan-customer-follow-up.hook";
import { CustomerDocument } from "../../../../customer/customer.model";
import { FormGroup } from "../../../../finance/billing/invoices/invoice-detail/FormGroup";
import { Link } from "react-router-dom";

const useStyles = makeStyles({
    multiline: {
        whiteSpace: "pre-wrap",
    },
});

interface AdhocCustomerFollowUpDetailCardProps {
    task: AdhocCustomerTaskDocument;
    customer: CustomerDocument;
    goBack: () => void;
}

export const AdhocCustomerFollowUpDetailCard = (props: AdhocCustomerFollowUpDetailCardProps) => {
    const classes = useStyles();

    const { task, customer, goBack } = props;

    const closeTask = useCloseTask(task, goBack);
    const planFollowUp = usePlanCustomerFollowUp(task, goBack);

    const menuButton = !task.hasBeenPerformed ? (
        <MenuButton>
            <ChangeTimeMenuItem taskId={task.id} />
        </MenuButton>
    ) : undefined;

    return (
        <Card>
            <CardHeader button={menuButton}>{task.customerName}</CardHeader>

            <CardContent>

                {task.hasBeenPerformed ? (
                    <FormGroup>
                        <label>Status</label>
                        <span>Opgaven er allerede blevet udført</span>
                    </FormGroup>
                ) : null}

                <FormGroup>
                    <label>Kunde</label>
                    <span>
                        <Link to={`/customers/context/${customer.id}`}>{customer.name}</Link>
                    </span>
                </FormGroup>

                <FormGroup>
                    <label>Telefon</label>
                    <span>
                        <a href={`tel:${customer.phoneNumber}`}>{customer.phoneNumber}</a>
                    </span>
                </FormGroup>

                <FormGroup>
                    <label>Hvad er der hændt?</label>
                    <span className={classes.multiline}>{task.whatHasHappened}</span>
                </FormGroup>

                <FormGroup>
                    <label>Hvad skal der gøres?</label>
                    <span className={classes.multiline}>{task.whatShouldBeDone}</span>
                </FormGroup>

                <FormGroup>
                    <label>Hvornår skal det udføres?</label>
                    <span>{moment(task.performAfterDate).format("D MMMM HH:mm")}</span>
                </FormGroup>

            </CardContent>

            {!task.hasBeenPerformed ? (
                <CardActions>
                    <NeutralAction onClick={closeTask}>Afslut opgave</NeutralAction>
                    <PositiveAction onClick={planFollowUp}>Planlæg opfølgning</PositiveAction>
                </CardActions>
            ) : null}

        </Card>
    );
};
